import { KeyboardEvent } from 'react'
import styled, { css } from 'styled-components'
import { GridColumn, RowId } from '../../types/grid.types'
import GridCell from './GridCell'

export interface GridRowProps<T> {
  row: T
  columns: GridColumn<T>[]
  rowId: RowId
  onRowClick?: (row: T) => void
}

export const GridRow = <T,>({ row, columns, rowId, onRowClick }: GridRowProps<T>) => {
  const clickable = !!onRowClick

  const handleKeyDown = (e: KeyboardEvent<HTMLTableRowElement>) => {
    if (clickable && (e.key === 'Enter' || e.key === ' ')) {
      e.preventDefault()
      onRowClick?.(row)
    }
  }

  return (
    <Tr
      $clickable={clickable}
      onClick={clickable ? () => onRowClick?.(row) : undefined}
      onKeyDown={handleKeyDown}
      tabIndex={clickable ? 0 : -1}
      aria-label={`שורה ${rowId}`}
    >
      {columns.map((col) => (
        <GridCell key={String(col.key)} column={col} row={row} />
      ))}
    </Tr>
  )
}

export default GridRow

const Tr = styled.tr<{ $clickable: boolean }>`
  transition: background ${({ theme }) => theme.motion.fast} ease;
  ${({ $clickable }) => $clickable && css`cursor: pointer;`}

  &:hover td {
    background: ${({ theme }) => theme.colors.bgLayout};
  }
  &:last-child td {
    border-bottom: 0;
  }
`
